import { createAsyncThunk } from '@reduxjs/toolkit';
import { siteService, userService, branchService } from 'services';
import {
  BranchError,
  BranchRequest,
  BranchResponse,
  GetKYDataApproveBySiteManageRequest,
  // 2025/02/25 FJ 3月分反映分 NO32 start
  GetKYDataApproveGroupBySiteManageRequest,
  // 2025/02/25 FJ 3月分反映分 NO32 end
  GetKYDataApproveBySiteManageResponse,
  GetSiteStatusLockedParams,
  GetSiteStatusLockedResponse,
  GetStatusKyRequest,
  GetStatusKyResponse,
  GetUserProfileError,
  GetUserProfileRequest,
  GetUserProfileResponse,
  ThunkAPI,
} from 'types';

export const getUserProfile = createAsyncThunk<
  GetUserProfileResponse,
  GetUserProfileRequest,
  ThunkAPI<GetUserProfileError>
>('layout/thunk/getUserProfile', async (params, { rejectWithValue }) => {
  try {
    const { data: user } = await userService.getUserProfile();
    return user;
  } catch (error) {
    return rejectWithValue(error);
  }
});

export const getLockStatus = createAsyncThunk<
  GetSiteStatusLockedResponse,
  GetSiteStatusLockedParams,
  ThunkAPI<GetUserProfileError>
>('layout/thunk/getLockStatus', async (params, { rejectWithValue }) => {
  try {
    const { data } = await siteService.getSiteStatusLocked(params);
    return data;
  } catch (error) {
    return rejectWithValue(error);
  }
});
export const getKYDataApproveBySiteManage = createAsyncThunk<
  GetKYDataApproveBySiteManageResponse,
  GetKYDataApproveBySiteManageRequest,
  ThunkAPI<GetUserProfileError>
>('layout/thunk/getKYDataApproveBySiteManage', async (params, { rejectWithValue }) => {
  try {
    const { data } = await siteService.getKYDataApproveBySiteManage(params);

    return data;
  } catch (error) {
    return rejectWithValue(error);
  }
});

// 2025/02/25 FJ 3月分反映分 NO32 start
export const getKYDataApproveGroupBySiteManage = createAsyncThunk<
  GetKYDataApproveBySiteManageResponse,
  GetKYDataApproveGroupBySiteManageRequest,
  ThunkAPI<GetUserProfileError>
>('layout/thunk/getKYDataApproveGroupBySiteManage', async (params, { rejectWithValue }) => {
  try {
    const { data } = await siteService.getKYDataApproveGroupBySiteManage(params);

    return data;
  } catch (error) {
    return rejectWithValue(error);
  }
});
// 2025/02/25 FJ 3月分反映分 NO32 end

export const getStatusKy = createAsyncThunk<
  GetStatusKyResponse,
  GetStatusKyRequest,
  ThunkAPI<GetUserProfileError>
>('layout/thunk/getStatusKy', async (params, { rejectWithValue }) => {
  try {
    const { data } = await siteService.getStatusKy(params);

    return data;
  } catch (error) {
    return rejectWithValue(error);
  }
});

export const getBranchs = createAsyncThunk<BranchResponse, undefined, ThunkAPI<BranchError>>(
  'branchs/thunk/action',
  async (_, { rejectWithValue }) => {
    try {
      const { data } = await branchService.getBranchs();
      const newBranchs = data.branchs.map((i) => ({
        ...i,
        key: i.kaisya_code + i.kyoten_code,
        value: i.kyoten_name,
      }));

      return { branchs: newBranchs };
    } catch (e) {
      console.log({ e, error: true });
      return rejectWithValue(e);
    }
  }
);

export const selectBranch = createAsyncThunk<BranchRequest, BranchRequest, ThunkAPI<BranchError>>(
  'selectBranch/thunk/action',
  async (params, { rejectWithValue }) => {
    try {
      await branchService.selectBranch(params);
      return params;
    } catch (e) {
      return rejectWithValue(e);
    }
  }
);
